angular.module('bribac.entities.scheduleFactory', [])
  /*
    Set value of maxRandomTestsPerDay to 0. It is 0 in new
    scheduleEditorComponent. This way there is no need to
    initialize it in onInit in scheduleEditorComponent.
  */
  .value('scheduleFactory', function scheduleFactory(data) {
    return angular.merge({
      id: null,
      template: false,
      name: null,
      maxRandomTestsPerDay: 0,
      earliestRandom: '',
      latestRandom: '',
      moodQuestion: [],
      weekdays: [],
      fixedTimes: []
    }, data)
  })
